import { colors, energyColors } from '../../types/Misc';

export interface Player {
	id: number;
	playerId: number;
	username: string;
	color: colors;
	energyColor: energyColors;

	isAdmin: boolean;
	isBot: boolean;

	factories: number;
	batteries: number;

	factoryEnergyArr: energyColors[];
	batteryEnergyArr: energyColors[];

	donationCup: number;
	donationCupArr: string[];

	totalDonation: number;
	carbonReserve: number;
	carbonFootprint: number;

	pr: number;
	prArr: energyColors[];

	seasonalCards: number[];
	summitCards: number[];

	equipment: number[];

	activeContractsAndAwards: number[];
	completedContracts: number[];
	failedContracts: number[];
	completedAwards: number[];
	completedContractsAndAwards: number[];

	modifiers: string[];
	oneTimeModifiers: string[];
	usedModifiers: string[];

	effectsUsedThisSeason: string[];
	cardIdPlayedThisTurn: number[];

	factoriesBuiltThisSeason: number;
	factoriesBuiltThisSeasonFromCarbonOnly: number;
	batteriesBuiltThisSeason: number;

	freezingPointStolenPlayerId: number;
	neighborFactoryEnergyColorId: number;

	resolveNextWinterSummitContractOrAward: boolean;
}

export const playerSimpleFields = [
	'id',
	'playerId',
	'username',
	'color',
	'energyColor',

	'factories',
	'batteries',

	'donationCup',

	'totalDonation',
	'carbonReserve',
	'carbonFootprint',

	'pr',

	'factoriesBuiltThisSeason',
	'factoriesBuiltThisSeasonFromCarbonOnly',
	'batteriesBuiltThisSeason',

	'freezingPointStolenPlayerId',
	'neighborFactoryEnergyColorId',

	'resolveNextWinterSummitContractOrAward',
];

export const playerArrayFields = [
	'factoryEnergyArr',
	'batteryEnergyArr',
	'donationCupArr',
	'prArr',

	'seasonalCards',
	'summitCards',

	'equipment',

	'activeContractsAndAwards',
	'completedContracts',
	'failedContracts',
	'completedAwards',
	'completedContractsAndAwards',

	'modifiers',
	'oneTimeModifiers',
	'usedModifiers',

	'effectsUsedThisSeason',
	'cardIdPlayedThisTurn',
];
